// Geometria de rota usada pelo painel.
//
// ENXUGADO EM 04/09/2026, quando a aba "Roteirização" deixou de GERAR rota de 1 dia e virou tela de
// configuração. Saíram daqui o otimizador local (vizinho-mais-próximo + 2-opt), o otimizador via
// OpenRouteService e o montador de URL do Google Maps: existiam só para aquele gerador e ficaram com
// ZERO consumidores. Isso também encerra um caminho de chamada PAGA ao ORS a partir do painel.
//
// Sobrou o `haversine`, que nada tem a ver com roteirização — é usado por Check-ins no Mapa,
// Histórico, Mapa ao vivo e reportStats para medir a distância entre o check-in e o cadastro.

export interface LatLng { lat: number; lng: number; }

// Distância em metros entre dois pontos (Haversine)
export function haversine(a: LatLng, b: LatLng): number {
  const R = 6371000;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}
